import React from 'react';
import Styles from '../../assets/styles.scss';
import { useOverlayScrollbars } from 'overlayscrollbars-react';

export const MarkdownCodeCopy = ({ children, className }) => {
	const ref = React.useRef<HTMLPreElement>();

	const [initialize] = useOverlayScrollbars({
		options: {
			scrollbars: {
				autoHide: 'leave'
			}
		}
	});

	React.useEffect(() => {
		const { current: root } = ref;
		const outer = root?.getElementsByTagName('code').item(0);

		if (root && outer) {
			initialize({
				target: root,
				elements: {
					viewport: outer
				}
			});
		}
	}, [initialize]);

	const headerTitle = React.useMemo(() => {
		const match = /language-(\w+)/.exec(children.props.className || '');

		return match?.[1] || '';
	}, [children.props.className]);

	return (
		<pre
			ref={ref}
			className={[className, Styles.mdCodePre].join(' ')}
			data-overlayscrollbars-initialize
		>
			<div className={Styles.mdCodePreHeader}>
				<span className={Styles.mdCodePreHeaderTitle}>{headerTitle}</span>
			</div>
			{children}
		</pre>
	);
};
